import { HTTP_TOKEN } from "./http";

export const getDashboards = (params) => {
  return HTTP_TOKEN.get("dashboard", { params }).then((result) => {
    return result.data;
  });
};

export const getDashboard = (dashId) => {
  return HTTP_TOKEN.get(`dashboard/${dashId}`).then((result) => {
    return result.data;
  });
};

export const createDashboard = (data) => {
  return HTTP_TOKEN.post("dashboard", data).then((result) => {
    return result.data;
  });
};

export const updateDashboard = (dashId, data) => {
  return HTTP_TOKEN.put(`dashboard/${dashId}`, data).then((result) => {
    return result.data;
  });
};

export const deleteDashboard = (dashId) => {
  return HTTP_TOKEN.delete(`dashboard/${dashId}`, {}).then((result) => {
    return result.data;
  });
};
